import { render } from "./ReferenceManagement.vue?vue&type=template&id=ccbd3be0&scoped=true"
import script from "./ReferenceManagement.vue?vue&type=script&lang=js"
export * from "./ReferenceManagement.vue?vue&type=script&lang=js"

import "./ReferenceManagement.vue?vue&type=style&index=0&id=ccbd3be0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbd3be0"]])

export default __exports__